export default __webpack_public_path__ + "static/media/1006.1a35b8aa.svg";